import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-force-update-screen',
  standalone: true,
  imports: [CardModule, ButtonModule],
  template: `
    <div class="force-update-overlay" aria-label="force-update-screen">
      <p-card styleClass="force-update-card">
        <div class="force-update-content">
          <i class="pi pi-cloud-download text-6xl text-orange-500"></i>
          <h2 class="text-2xl font-bold m-0">Mise a jour requise</h2>
          <p class="text-700 m-0 line-height-3">
            Votre version ({{ currentVersion }}) n'est plus supportee.
            La version minimum requise est {{ minimumVersion }}.
          </p>
          <div class="force-update-actions">
            <p-button
              label="Mettre a jour"
              icon="pi pi-refresh"
              (click)="forceUpdate()"
              severity="warn">
            </p-button>
            <p-button
              label="Reessayer la verification"
              icon="pi pi-sync"
              (click)="retry.emit()"
              [outlined]="true"
              severity="secondary">
            </p-button>
          </div>
        </div>
      </p-card>
    </div>
  `,
  styles: [`
    .force-update-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9999;
      background: var(--surface-ground);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .force-update-card {
      max-width: 500px;
      width: 90%;
    }

    .force-update-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding: 1rem;
      text-align: center;
    }

    .force-update-actions {
      display: flex;
      gap: 0.75rem;
      flex-wrap: wrap;
      justify-content: center;
    }
  `]
})
export class ForceUpdateScreenComponent {
  @Input() currentVersion = '';
  @Input() minimumVersion = '';
  @Output() retry = new EventEmitter<void>();

  forceUpdate(): void {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => reg.unregister());
      });
    }
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    window.location.reload();
  }
}
